import React from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { useNavigate } from 'react-router-dom';
import { ButtonActionDrop } from '../../../../components/Buttons/ButtonActionDrop/ButtonActionDrop';
import { TextPage } from '../../../../components/TextPage/TextPage';
import './ProjectCard.scss';

// Иконки
import userCircleIcon from './img/bx-user-circle.svg';
import no_photo from './img/not-img.svg';
import star_icon from './img/bxs-star.svg'
import pin_icon from './img/bx-pin.svg'

interface Project {
    taskId: number;
    author: any;
    name: string;
    previewImage?: string;
    is_favorite?: boolean;
    is_pin?: boolean;
    attendee?: string[];
    image?: string | null
}

interface ProjectCardProps {
    project: Project;
    setSelectedProject: (project: Project) => void;
    setIsInfoProject: (value: boolean) => void;
    setIsModalAddProject: (value: boolean) => void;
    isShowAllExecutor?: boolean;
    arrNames?: (attendee?: string[], authorName?: string) => string[];
    authorName?: string;
    deleteProject?: (id: string | number) => void
    crm: boolean
    ticket: boolean
    fetchProjects: () => void
}


const ProjectCard: React.FC<ProjectCardProps> = ({
    project,
    setSelectedProject,
    setIsInfoProject,
    setIsModalAddProject,
    isShowAllExecutor = false,
    deleteProject = () => { },
    arrNames = () => { return [] },
    authorName,
    crm = false,
    ticket = false,
    fetchProjects
}) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }
    const navigate = useNavigate();
    const { attendee, taskId, name, image, is_favorite, is_pin } = project;
    const author = project?.author?.id
    const client_id = localStorage.getItem('client_id');

    const handleCardClick = () => {
        setSelectedProject(project);
        if (crm) {
            sessionStorage.setItem('crmProjectName', name);
            sessionStorage.setItem('crmProjectId', taskId.toString());
        } else if (ticket) {
            sessionStorage.setItem('ticketProjectName', name);
            sessionStorage.setItem('ticketProjectId', taskId.toString());
        } else {
            sessionStorage.setItem('taskProjectName', name);
            sessionStorage.setItem('taskProjectId', taskId.toString());
        }

        if (crm) {
            navigate(`/crm/crm-list/${taskId}`);
        } else if (ticket) {
            navigate(`/ticket/ticket-list/${taskId}`);
        } else {
            navigate(`/tasks/task-list/${taskId}`);
        }
    };

    const handleInfoClick = (e: React.MouseEvent<HTMLImageElement>) => {
        setSelectedProject(project);
        setIsInfoProject(true);
        setIsModalAddProject(true);
        if (crm) {
            navigate(`/crm/project-for-crm/project/${taskId}`);
        } else if (ticket) {
            navigate(`/ticket/project-for-ticket/project/${taskId}`);
        } else {
            navigate(`/tasks/project-for-tasks/${taskId}`);
        }
        sessionStorage.setItem('selectedProject', JSON.stringify(project));
    };

    // Добавить в избранное
    const fetchAddFavoriteProject = (is_favorite: boolean) => {
        let url: string;
        if (crm) {
            url = `https://portals.ecomru.ru/api/crm/projects/{project_id}/favorite`
        } else if (ticket) {
            url = `https://portals.ecomru.ru/api/ticket/project/{project_id}/favorite`
        } else {
            url = `https://portals.ecomru.ru/api/v3/tasks/project/favorite`
        }

        const body = JSON.stringify({
            project_id: taskId,
            is_favorite: is_favorite,
        });

        fetch(url, { method: 'POST', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
                setTimeout(() => fetchProjects(), 500)
            })
            .catch((err) => console.error(err));
    };

    // Добавить в закрепленное CRM
    const fetchAddPinProject = (is_pin: boolean) => {
        let url = `https://portals.ecomru.ru/api/v3/tasks/project/pin`
        if (ticket) {
            url = `https://portals.ecomru.ru/api/ticket/project/{project_id}/pin`
        }
        if (crm) {
            url = `https://portals.ecomru.ru/api/crm/projects/{project_id}/pin`
        }

        const body = JSON.stringify({
            project_id: taskId,
            is_pin: is_pin,
        });

        fetch(url, { method: 'POST', headers, body })
            .then(res => {
                if (!res?.ok) { throw new Error('bad response') }
                return res.json()
            })
            .then(json => {
               setTimeout(() => fetchProjects(), 500)
            })
            .catch((err) => console.error(err));
    };

    const btns = [
        ...(is_favorite
            ? [
                {
                    btn: 'Удалить из избранного',
                    func: () => {
                        fetchAddFavoriteProject(false)
                    },
                },
            ]
            : [
                {
                    btn: 'Добавить в избранное',
                    func: () => {
                        fetchAddFavoriteProject(true)
                    },
                },
            ]),
        ...(is_pin
            ? [
                {
                    btn: 'Открепить проект',
                    func: () => {
                        fetchAddPinProject(false)
                    },
                },
            ]
            : [
                {
                    btn: 'Закрепить проект',
                    func: () => {
                        fetchAddPinProject(true)
                    },
                },
            ]),
        ...(author == client_id ?
            [
                {
                    btn: 'Редактировать',
                    func: (e: React.MouseEvent<HTMLImageElement>) => handleInfoClick(e),
                },
                {
                    btn: 'Удалить',
                    func: (e: React.MouseEvent<HTMLImageElement>) => deleteProject(taskId),
                }
            ]
            :
            [])
    ];


    return (
        <div
            className='project-card'
            style={{ border: is_pin ? '2px solid #1890FF' : undefined }}
            onClick={handleCardClick}
        >
            <div className='project-card__top-content'>
                <div className='project-card__header'>
                    <div className='project-card__statistic-tasks'></div>
                    <div className='project-card__header'>
                        {author == client_id && <img src={userCircleIcon} alt='Избранный' />}
                        {is_favorite && <img src={star_icon} />}
                        {is_pin && <img src={pin_icon} alt='Закрепленный' />}
                        {taskId !== -1 &&
                            <ButtonActionDrop
                                size='s'
                                id={taskId}
                                btns={btns}
                            />}
                    </div>
                </div>
                <div className='project-card__img-box'>
                    <img
                        className='project-card__img'
                        alt='project preview'
                        src={image || no_photo}
                        onError={(e) => (e.currentTarget.src = no_photo)}
                    />
                </div>
            </div>

            <div className='project-card__medium-content'>
                <h3 className='project-card__title'>{name}</h3>
            </div>

            <div className='project-card__bottom-content'>
                {attendee?.length ?
                    <div className='project-card__employees-container'>
                        {isShowAllExecutor ? arrNames(attendee, authorName) : arrNames(attendee, authorName)?.slice(0, 6)}
                        {!isShowAllExecutor && attendee?.length && attendee.length > 6 && (
                            <p className='project-card__sum-executor'>+<span>{attendee.length - 6}</span></p>
                        )}
                    </div>
                    :
                    <TextPage
                        text='Нет участгиков'
                        style={{
                            fontSize: '12px',
                            color: '#636D65'
                        }}
                    />
                }

            </div>
        </div>
    );
};

export default ProjectCard;
